import {
  isRedirectToType,
  isRemainingTimeType,
} from "@circle-react/helpers/paywallCustomizationHelpers";
import {
  ACTION_TYPE,
  COUNTDOWN_TYPE,
  type CountdownProperties,
} from "@circle-react/types/PaywallCustomization";

const serializeCountdownProperties = (
  countdownProperties: Partial<CountdownProperties>,
): CountdownProperties => ({
  enabled: countdownProperties?.enabled ?? false,
  displayed_text: countdownProperties?.displayed_text || "",
  action: isRedirectToType(countdownProperties?.action?.action_type)
    ? {
        action_type: ACTION_TYPE.REDIRECT_TO,
        redirect_to: countdownProperties?.action?.redirect_to,
      }
    : {
        action_type: ACTION_TYPE.DO_NOTHING,
      },
  ...(isRemainingTimeType(countdownProperties?.countdown_type)
    ? {
        countdown_type: COUNTDOWN_TYPE.REMAINING_TIME,
        remaining_time: Number(countdownProperties?.remaining_time),
        remaining_time_interval: "minutes",
      }
    : {
        countdown_type: COUNTDOWN_TYPE.FINISH_AT,
        finish_at: countdownProperties.finish_at
          ? new Date(countdownProperties.finish_at).toISOString()
          : new Date().toISOString(),
      }),
});

export const paywallCustomizationSerializer = {
  serializeCountdownProperties,
};
